import React, { ReactElement, useState } from 'react'
import { Button, List, Popconfirm } from 'antd'
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import HeaderPage from '@components/atoms/HeaderPage'
import { useFetch, useRouter } from '@customHooks'
import { ContainerTabela } from '@pages/style'
import api from '@services/api'

export default function Kits(): ReactElement {
  const { navigate } = useRouter()
  const [reload, setReload] = useState(false)

  // const onDelete = async (id: number) => {
  //   await api.delete(`/atividade/${id}`).finally(() => setReload(!reload))
  // }

  return (
    <ContainerTabela>
      <HeaderPage
        title='Montar Kit'
        extra={[
          <Button
            key='insert'
            icon={<PlusOutlined />}
            size='large'
            type='primary'
            onClick={() => navigate('/vendas/produtos/montarkit/novo')}
          >
            Novo
          </Button>,
        ]}
      />
      <List
        style={{ backgroundColor: '#FFF' }}
        itemLayout='horizontal'
        bordered
        // dataSource={}
        // loading={}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                key='edit'
                onClick={() =>
                  navigate(`/vendas/produtos/montarkit/${''}`, {
                    state: item,
                  })
                }
                type='link'
                icon={<EditOutlined />}
              >
                Editar
              </Button>,
              <Popconfirm
                key='delete'
                title='Deseja realmente excluir este registro?'
                // onConfirm={() => onDelete()}
              >
                <Button key='delete' type='text' icon={<DeleteOutlined />}>
                  Apagar
                </Button>
              </Popconfirm>,
            ]}
          >
            <List.Item.Meta title='Descrição do Kit' />
            <List.Item.Meta title='Código do Componente' />
            <List.Item.Meta title='Descrição do Componente' />
            <List.Item.Meta title='Quantidade' />
            <List.Item.Meta title='Tipo' />
          </List.Item>
        )}
      />
    </ContainerTabela>
  )
}
